export const parseAvailability = (slot) => ({
    id: slot?.id,
    experienceScheduleId: slot?.experienceScheduleId,
    // scheduleCode: '',
    // experienceScheduleCode: '',
    experienceDetailId: slot?.experienceDetailId,
    start: slot?.localDateTimeStart,
    startUTC: slot?.utcDateTimeStart,
    end: slot?.localDateTimeEnd,
    endUTC: slot?.utcDateTimeEnd,
    timezone: slot?.timezone,
    available: slot?.available || false,
    price: slot?.totalPricing?.original,
    priceTotal: slot?.totalPricing?.finalPrice,
    currency: slot?.currency,
    // duration: '',
    capacity: slot?.capacity,
    // priceGroupId: '',
    vacancies: slot?.vacancies,
    // cutoffSeconds: '',
    units: slot?.units,
    unitPricing: slot?.unitPricing || [],
});
